import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ArticleForm from '../components/article-form';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import ButtonLink from '../components/button-link';
import PageHeader from '../components/page-header';
import './page.css';
import api from '../api';

const ArticlePage = () => {
  const { id } = useParams();

  const [previewLink, setPreviewLink] = useState(null);

  useEffect(() => {
    if (id) {
      api.previewLinks.article(
        id,
        link => {
          setPreviewLink(link);
        },
      );
    }
  }, [id]);

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} un article`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/articles"
            theme="danger"
          />

          {id && previewLink &&
            <ButtonLink
              className="page_action-button"
              icon="remove_red_eye"
              label="Voir en ligne"
              href={`${process.env.REACT_APP_API_HOST}${previewLink}`}
              theme="info"
              target="_blank"
            />
          }
        </div>

        <ArticleForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default ArticlePage;
